import React from 'react';

import { useCanvasSketchContext } from '../../contexts/CanvasSketchContext';
import { useSessionContext } from '../../contexts/SessionContext';

import { useCanvasDrawStyles } from './styles';

export const CanvasSketch = () => {
  const styles = useCanvasDrawStyles();
  const { canvasSketchSize } = useSessionContext();

  const { canvasSketchRef, mouseDown, mouseMove, mouseUp, mouseOut } =
    useCanvasSketchContext();

  return (
    <canvas
      ref={canvasSketchRef}
      width={canvasSketchSize.width}
      height={canvasSketchSize.height}
      onMouseDown={(event: any) => mouseDown(event)}
      onMouseMove={(event: any) => mouseMove(event)}
      onMouseUp={mouseUp}
      onMouseOut={mouseOut}
      style={styles.sketchCanvas as React.CSSProperties}
    />
  );
};
